module.exports = __webpack_public_path__ + "img/17_fineStaff_lc.0da13e68.png";